export default "__VITE_ASSET__f65af431__"